import { render, staticRenderFns } from "./MetamaskConfirm.vue?vue&type=template&id=9153727c&scoped=true&"
import script from "./MetamaskConfirm.vue?vue&type=script&lang=js&"
export * from "./MetamaskConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9153727c",
  null
  
)

export default component.exports